export enum PopupStates {
	OPENED = 'opened',
	CLOSED = 'closed',
}
